module.exports = __webpack_public_path__ + "media/images/report-19f1518dfd7c9a15d4e39b7b81bd3b1e.jpg";